export default __webpack_public_path__ + "static/media/logoLight.5dd59a84.webp";